import React, { FC } from "react";
import { SignInOrSignUp } from "./SignInOrSignUp";

export const SignInPage: FC = () => {
  return <SignInOrSignUp variant="signIn" />;
};
